import {
  HighFrequency_GameConfigStatus,
  type HighFrequencyGameConfigQuery,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

export default defineNuxtRouteMiddleware(async (to) => {
  const { getHighFrequencyGameIdInCorrectCase } = useHighFrequencyGamesOfLicensedTerritory()

  const licensedTerritory = useLicensedTerritory({ raw: true })
  const gameId = getHighFrequencyGameIdInCorrectCase(String(to.params.gameId))

  try {
    const response = await useNuxtApp().$apollo.clients.default.query<HighFrequencyGameConfigQuery>(
      {
        fetchPolicy: 'cache-first',
        query: HighFrequencyGameConfigDocument,
        variables: { gameId, licensedTerritory },
      },
    )

    const config = response.data.highFrequencyGameConfig
    if (isGraphqlSuccess(config) && config.status === HighFrequency_GameConfigStatus.Inactive) {
      return navigateTo('/', { redirectCode: 302 })
    }
  } catch {
    return navigateTo('/', { redirectCode: 302 })
  }
})
